import {
  APP_LOCALE_LABELS,
  type AppLocale,
} from "@airange/shared/i18n-platform-locale";
import { createLocaleSwitchShell, type LocaleControllerLike } from "./locale-switch";

export type PlatformLocaleSwitchConfig = {
  controller: LocaleControllerLike;
  width?: number;
};

export function createPlatformLocaleSwitch(config: PlatformLocaleSwitchConfig) {
  return createLocaleSwitchShell({
    controller: config.controller,
    getLocaleLabel: (locale: AppLocale) => APP_LOCALE_LABELS[locale],
    ...(config.width === undefined ? {} : { width: config.width }),
  });
}
